import { isTabletPortraitDown, ProviderUser, Spinner, Toast } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { IInjectedRootStore } from 'stores';
import { Company, Email, Name, Phone } from '.';
import { SubCategoryLink } from '../components';
import { isActiveFor, switchForRoutes } from '../shared';
import * as S from '../shared.styles';

interface IOverviewState {
    message?: string;
}

@inject('rootStore')
@observer
export class Overview extends React.Component<{}, IOverviewState> {
    constructor(props: object) {
        super(props);
        this.state = {
            message: undefined,
        };
    }
    public render(): React.ReactElement {
        if (!this.currentUser) {
            return <Spinner />;
        }
        return (
            <S.SubCategoryRow>
                {isTabletPortraitDown() && this.renderMobile()}
                {!isTabletPortraitDown() && this.renderLeftColumn()}
                {!isTabletPortraitDown() && this.renderRightColumn()}
            </S.SubCategoryRow>
        );
    }

    private readonly renderMobile = (): React.ReactElement => (
        <Switch>
            <Route path="/settings/overview" exact={true} render={this.renderLeftColumn} />
            <Route path="/settings/overview/name" exact={true} component={Name} />
            <Route path="/settings/overview/email" exact={true} component={Email} />
            <Route path="/settings/overview/phone" exact={true} component={Phone} />
            <Route path="/settings/overview/company" exact={true} component={Company} />
        </Switch>
    );

    private readonly renderLeftColumn = (): React.ReactElement => (
        <S.SubCategoryCol>
            <S.SubCategoryHeader>
                {isTabletPortraitDown() && (
                    <S.ReturnLink to="/settings">
                        {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                    </S.ReturnLink>
                )}
                <S.SubCategoryH1>Overview</S.SubCategoryH1>
            </S.SubCategoryHeader>
            <SubCategoryLink
                first={true}
                to="/settings/overview/name"
                label="Name"
                value={this.name}
                isActive={isActiveFor('/settings/overview', '/settings')}
            />
            <SubCategoryLink to="/settings/overview/email" label="Email" value={this.email} />
            <SubCategoryLink to="/settings/overview/phone" label="Phone" value={this.phone} />
            <SubCategoryLink to="/settings/overview/company" label="Company" value={this.company} />
            <Toast message={this.state.message as string} onClose={this.handleMessageClose} />
        </S.SubCategoryCol>
    );

    private readonly renderRightColumn = (): React.ReactElement => (
        <S.SubCategoryCol>
            {switchForRoutes([
                { path: '/settings/overview/name', component: Name },
                { path: '/settings/overview/email', component: Email },
                { path: '/settings/overview/phone', component: Phone },
                { path: '/settings/overview/company', component: Company },
            ])}
        </S.SubCategoryCol>
    );

    private get injected(): IInjectedRootStore {
        return this.props as IInjectedRootStore;
    }
    private get currentUser(): ProviderUser | undefined {
        return this.injected.rootStore.settingsStore.getCurrentUser(this.injected.rootStore.userId);
    }
    private get name(): string | undefined {
        return this.currentUser && `${this.currentUser.first} ${this.currentUser.last}`;
    }
    private get email(): string | undefined {
        return this.currentUser && this.currentUser.email;
    }
    private get phone(): string | undefined {
        return this.currentUser && this.currentUser.phone;
    }
    private get company(): string | undefined {
        return this.injected.rootStore.companyName || '';
    }

    private handleMessageClose = (): void => {
        this.setState({
            message: undefined,
        });
    };
}
